import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/layouts/Main'
import Embed from '@/layouts/Embed'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Main
    },
    {
      path: '/start',
      component: Main,
      props: {
        preloadIntakeModal: true
      }
    },
    {
      path: '/checklist',
      component: Main,
      props: {
        viewChecklist: true
      }
    },
    {
      path: '/embed',
      component: Embed
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router.js